import { render, staticRenderFns } from "./AttachTypeField.vue?vue&type=template&id=24989f98&scoped=true"
import script from "./AttachTypeField.vue?vue&type=script&lang=js"
export * from "./AttachTypeField.vue?vue&type=script&lang=js"
import style0 from "./AttachTypeField.vue?vue&type=style&index=0&id=24989f98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24989f98",
  null
  
)

export default component.exports